import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config.js";
import { useAuth } from "../login/AuthContext";
import { toast } from "react-toastify";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import "../packages/Packages.css";
import "../customers/customers.css";
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

export default function PdksPackages() {
  const { token } = useAuth();
  const headers = { Authorization: `Bearer ${token}` };
  const [paketler, setPaketler] = useState([]);
  const [ek, setEk] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    paketId: null, paketAdi: "PDKS Standard 10", edition: "STANDARD",
    maxPersonnel: 10, maxKullaniciSayisi: 2, sira: 1, selectedEkModulIds: [],
  });

  const load = useCallback(async () => {
    try {
      const [p, e] = await Promise.all([
        axios.get(`${config.baseURL}/pdks-paketler/paket-detay-list`, { headers }),
        axios.get(`${config.baseURL}/pdks-ek-moduller`, { headers }),
      ]);
      setPaketler(p.data || []);
      setEk(e.data || []);
    } catch {
      toast.error("PDKS paketleri yuklenemedi");
    }
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      await axios.post(`${config.baseURL}/pdks-paketler/create`, form, { headers });
      toast.success("Kaydedildi");
      setOpen(false);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.message || "Kayit basarisiz");
    }
  };

  return (
    <div className="cari-listesi-container">
      <div className="header"><h1>PDKS Paketleri</h1></div>
      <div className="search-bar">
        <Button variant="contained" startIcon={<AddCircleOutline />} onClick={() => setOpen(true)}>Ekle</Button>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead><tr><th>Ad</th><th>Paket</th><th>Personel</th><th>Kullanici</th><th>Ek modul</th></tr></thead>
          <tbody>
            {paketler.map((p) => (
              <tr key={p.Id}>
                <td>{p.Adi}</td>
                <td>{p.Edition}</td>
                <td>{p.MaxPersonnel}</td>
                <td>{p.MaxKullaniciSayisi}</td>
                <td>{(p.EkModuller || []).map((m) => m.Kod).join(", ") || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Drawer open={open} onClose={() => setOpen(false)} direction="right" className="custom-drawer" zIndex={600}>
        <Box p={2.5}>
          <Typography variant="h6" mb={2}>PDKS Paket</Typography>
          <TextField fullWidth label="Ad" margin="dense" value={form.paketAdi}
            onChange={(e) => setForm({ ...form, paketAdi: e.target.value })} />
          <TextField select fullWidth label="Edition" margin="dense" SelectProps={{ native: true }} value={form.edition}
            onChange={(e) => setForm({ ...form, edition: e.target.value, selectedEkModulIds: e.target.value === "STANDARD" ? [] : form.selectedEkModulIds })}>
            <option value="STANDARD">STANDARD</option>
            <option value="PRO">PRO</option>
          </TextField>
          <TextField fullWidth type="number" label="Max personel" margin="dense" value={form.maxPersonnel}
            onChange={(e) => setForm({ ...form, maxPersonnel: e.target.value })} />
          <TextField fullWidth type="number" label="Max kullanici" margin="dense" value={form.maxKullaniciSayisi}
            onChange={(e) => setForm({ ...form, maxKullaniciSayisi: e.target.value })} />
          {form.edition === "PRO" && ek.map((m) => (
            <FormControlLabel key={m.Id} control={
              <Checkbox checked={form.selectedEkModulIds.includes(m.Id)}
                onChange={() => {
                  const set = new Set(form.selectedEkModulIds);
                  if (set.has(m.Id)) set.delete(m.Id); else set.add(m.Id);
                  setForm({ ...form, selectedEkModulIds: [...set] });
                }} />
            } label={`${m.Kod} — ${m.Adi}`} />
          ))}
          <Box mt={2}><Button variant="contained" onClick={save}>Kaydet</Button></Box>
        </Box>
      </Drawer>
    </div>
  );
}
